<template>
  <div class="page fq">
    <div class="fq-detail">
      <img src="./images/img_afq@2x.png">
    
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  mounted () {
    this.$bus.$emit('ready')
  }

}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.fq {
  background: #F7F7F7;
  
  .fq-detail{
    img {
      width: 100%;
    }
  }
  
}</style>